const KEY = 'hamssah_v2_token';
const LEGACY_KEY = 'hamssah_v2_refresh';
const USER_CACHE_KEY = 'hamssah_admin_user_snapshot';
/** localStorage ping so other tabs reload the shared refresh cookie. Not the JWT. */
export const AUTH_SYNC_KEY = 'hamssah_v2_auth_sync';

function migrateLegacyTokensOnce(): void {
  const legacyAccess = localStorage.getItem(KEY);
  const legacyRefresh = localStorage.getItem(LEGACY_KEY);
  if (!legacyAccess && !legacyRefresh) return;
  if (legacyAccess && !sessionStorage.getItem(KEY)) {
    sessionStorage.setItem(KEY, legacyAccess);
  }
  localStorage.removeItem(KEY);
  localStorage.removeItem(LEGACY_KEY);
}

migrateLegacyTokensOnce();

export function getToken(): string | null {
  return sessionStorage.getItem(KEY);
}

export function setAccessToken(access: string) {
  sessionStorage.setItem(KEY, access);
}

export function publishAuthSync(kind: 'login' | 'logout') {
  try {
    localStorage.setItem(AUTH_SYNC_KEY, JSON.stringify({ kind, t: Date.now() }));
  } catch {
    /* private mode */
  }
}

/** Drop this tab's access token. Does not ping other tabs. */
export function dropAccessSession() {
  sessionStorage.removeItem(KEY);
  sessionStorage.removeItem(USER_CACHE_KEY);
}

/** @deprecated refresh token lives in httpOnly cookie — kept for call-site compat */
export function setTokens(access: string, _refresh?: string) {
  setAccessToken(access);
}

export function setToken(t: string) {
  setAccessToken(t);
}

export function clearTokens() {
  dropAccessSession();
  localStorage.removeItem(KEY);
  localStorage.removeItem(LEGACY_KEY);
}
